import { ReactElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";

export async function svgToMapImage(svg: ReactElement) {
  const svgMarkup = renderToStaticMarkup(svg);

  const blob = new Blob([svgMarkup], {
    type: "image/svg+xml",
  });

  const url = URL.createObjectURL(blob);

  const image = await loadImage(url);

  URL.revokeObjectURL(url);

  return image;
}

function loadImage(source: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = reject;

    image.src = source;
  });
}
